var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"radio-icon",class:_vm.getRadioColor(_vm.radio)})}
var staticRenderFns = []

export { render, staticRenderFns }